import React from 'react';
import { FCWithChildren } from '@types';

const SeparatorLine: FCWithChildren<{}> = () => {
  return <div className="border-b flex w-full" />;
};

export default SeparatorLine;
